module.exports = __webpack_public_path__ + "src/img/artist/work05_2.jpg?e1457a00a0c473ac62ce4e65fc130c6f";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/work05_2.jpg
// module id = 155
// module chunks = 0